@if (panel.available()) {
  <div class="ai-ask-bar">
    <dx-text-box class="ai-ask-input" [(value)]="text" [placeholder]="placeholder()" stylingMode="outlined"
                 (onEnterKey)="ask()" valueChangeEvent="input" />
    <dx-button class="ai-ask-attach" icon="attach" stylingMode="text" hint="Ask about a document" (onClick)="attach()" />
  </div>
  <dx-button class="ai-ask-compact" icon="fa-solid fa-wand-magic-sparkles" stylingMode="text" hint="Crystal AI" (onClick)="openPanel()" />
}
